import { createContext } from "react";
import { ColumnInstance } from "react-table";

export default createContext<ColumnInstance<any>[]>([]);
